import { baseApi } from './base';
import { Country } from '../../types/interfaces';

export const getCountries = async () => {
  const response = await baseApi.get<Country[]>(`/v1/public/country`);

  return response.data;
};
